import { useState } from 'react';
import { Button, Icon, Menu, MenuItem, ThemeProvider } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import OptimizerService from '../service/OptimizerService';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';

function AddDefaultButton() {
	const [showConfirm, setShowConfirm] = useState(false);

	const handleClick = event => {
		OptimizerService.addDefaultOptimizers().then(result => {
			dispatch({ type: 'optimizerTable/event/setNeedDataReload' });
		});
	};

	return (
		<>
			<Button aria-controls="simple-menu" aria-haspopup="true" onClick={() => setShowConfirm(true)} className="whitespace-nowrap mx-8" variant="contained" color="secondary" startIcon={<Icon className="hidden sm:flex">add</Icon>}>
				Add default optimizers
			</Button>
			<ConfirmDialog show={showConfirm} title="Add default optimizers" description="Do you want to add the default optimizers?" onYes={() => handleClick()} onClose={() => setShowConfirm(false)} />
		</>
	);
}

export default AddDefaultButton;
